<template>
    <v-text-field
        v-bind="$props"
        :value="value"
        class="text-field"
        flat
        :solo="solo"
        :append-icon="passwordHidden ? 'mdi-eye' : 'mdi-eye-off'"
        @click:append="() => (passwordHidden = !passwordHidden)"
        :type="passwordHidden ? 'password' : 'text'"
        v-on:input="updateValue"
        :hide-details="hideDetails ? true : false"
        :disabled="disabled"
    ></v-text-field>
</template>

<script>
export default {
    props: [
        "placeholder",
        "label",
        "required",
        "rules",
        "value",
        "hideDetails",
        "solo",
        "disabled",
    ],
    data() {
        return {
            intervalValue: null,
            passwordHidden: true,
        };
    },
    methods: {
        updateValue: function (value) {
            this.$emit("input", value);
        },
    },
};
</script>

<style lang="sass">
.text-field
    &.v-text-field--solo
        border-radius: 0
        position: relative

    .v-input__control > .v-input__slot
        margin-bottom: 0

    .v-text-field__details
        position: relative
        top: 2px

    input:-webkit-autofill
        -webkit-box-shadow: 0 0 0 1000px white inset
</style>
